import Box, { type BoxProps } from "../../layout/Box/Box.web";
import { FormRowSharedProps } from "./FormRow.props";

type FormRowProps = { children: React.ReactNode } & FormRowSharedProps &
  BoxProps;

const FormRow = ({ spacing = undefined, children, ...props }: FormRowProps) => {
  return (
    <Box
      {...props}
      display="flex"
      flexDirection={{ base: "column", sm: "row" }}
      columnGap={{ sm: "md" }}
      rowGap={{ base: spacing || "30px", sm: "none" }}
    >
      {children}
    </Box>
  );
};

export default FormRow;
